import isUndefined from 'lodash/isUndefined';
import { GA_ALL_SOCIALS, GA_LOGIN_CATEGORY } from '../constants/analytics';
import { IAnalyticsDimensionsProps } from './interfaces';

// Used to capitalize labels once a tracking is triggered
export const capitalize = (value: string) => {
    if (!isUndefined(value)) {
        return value.charAt(0).toUpperCase() + value.slice(1);
    } else {
        return value;
    }
};

export const getSocialConnectionsKey = (connectedSocials: string[]) => {
    let key = '';

    GA_ALL_SOCIALS.forEach((social: any) => {
        if (
            Array.isArray(connectedSocials) &&
            connectedSocials?.includes(social)
        ) {
            key = key + social;
        }
    });

    return key;
};

export const getAnalyticsCategory = (analytics?: IAnalyticsDimensionsProps) =>
    analytics?.categoryOverride || GA_LOGIN_CATEGORY;
